import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';
import { priceFormatter } from '@noths/polaris-client-utils';
import type { Price as PriceType } from '@noths/polaris-dev-ts-types';

import * as styles from './styles';

type Props = PriceType & {
  className?: string;
  testId?: string;
  type?: 'normal' | 'previous' | 'sale';
};

export const Price = ({ amount, className, currency, testId, type = 'normal' }: Props) => {
  return (
    <p
      className={className}
      css={[styles.price, type === 'sale' && styles.sale, type === 'previous' && styles.previous]}
      data-testid={testId}
    >
      {type === 'sale' && <span css={visuallyHidden}>Sale price </span>}
      {type === 'previous' && <span css={visuallyHidden}>Regular price </span>}
      {priceFormatter(currency, amount)}
    </p>
  );
};
